import "../styles/globals.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { StoreProvider } from "@/lib/store";
import Landing from "@/screens/Landing";
import Room from "@/screens/Room";
import { Enter } from "@/screens/Gate";
import NotFound from "@/screens/NotFound";

export function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/join" element={<Enter />} />
          {/* One door for everyone. The host link just pre-ticks the box. */}
          <Route path="/host" element={<Navigate to="/join?host=1" replace />} />
          <Route path="/room/:code" element={<Room />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  );
}
